import {
  Box,
  Button,
  TextField,
  ThemeProvider,
  createTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import swal from "sweetalert";
import { jwtDecode } from "jwt-decode";

let theme = createTheme({
  palette: {
    primary: {
      main: "#0052cc",
    },
    secondary: {
      main: "#1A8D90",
    },
  },
});

const Form = ({ callBackAfterSubmit, formData }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const reg = /^\+?2519\d{8}$|^\+?2517\d{8}$|^09\d{8}$|^07\d{8}$/;
    if (!reg.test(phoneNumber) || phoneNumberError || phoneNumber === "") {
      setPhoneNumberError(true);
      swal("Error", "Please Enter a Valid Phone Number", "error");
      return;
    }
    const resp = await fetch(
      process.env.REACT_APP_BACKEND_URL + "/auth/resetPassword",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const json = await resp.json();
    if (resp.status === 200) {
      swal("Success", json.message, "success");
      callBackAfterSubmit();
    } else {
      swal("Failed", json.message, "error");
    }
  };

  const handlePhoneChange = (e) => {
    setPhoneNumberError(false);
    setPhoneNumber(e.target.value);
  };

  return (
    <>
      <Box
        m="20px"
        mt={"5rem"}
        sx={{
          background: "white",
          width: "90%",
          maxWidth: "800px",
          boxSizing: "border-box",
          px: "1rem",
          py: "2rem",
          zIndex: 999,
          margin: "0 auto",
          borderRadius: "15px",
        }}
      >
        <Header subtitle={"Reset Password"} />
        <ThemeProvider theme={theme}>
          <form onSubmit={handleFormSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                pt: "3rem",
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="tel"
                label="Phone Number"
                error={phoneNumberError}
                required
                onChange={handlePhoneChange}
                value={phoneNumber}
                name="phone Number"
                disabled={formData != null}
                sx={{ gridColumn: "span 2", ml: "1.5rem" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Reset Password
              </Button>
            </Box>
          </form>
        </ThemeProvider>
      </Box>
    </>
  );
};

export default Form;
